import { useEffect, useState } from "react";
import { ContentTypeView, Link, SessionRole } from "nystem-components";
import app from "nystem";
import { CastContext } from "../../client/castContext.js";
import CastLocation from "./location.js";

const CastTest = () => {
  const [hd, setHd] = useState(() => localStorage.getItem("mediaqueueCastHD") !== "false");
  const [video, setVideo] = useState();
  const [playback, setPlayback] = useState();
  const [saved, setSaved] = useState();
  const [subtitles, setSubtitles] = useState(false);

  useEffect(() => localStorage.setItem("mediaqueueCastHD", String(hd)), [hd]);

  const request = async (op, args) => {
    if (op === "display.player") setVideo(args.video);
  };
  const feedback = (playback) => {
    setPlayback(playback);
    window.dispatchEvent(new CustomEvent("mediaqueuePlayback", { detail: playback }));
  };

  return (
    <CastContext.Provider
      value={{ state: { connected: true }, hd, setHd, request, feedback, saved: setSaved, subtitles, setSubtitles }}
    >
      <SessionRole userrole="logged-out">
        <ContentTypeView contentType="adminUser" format="login" />
      </SessionRole>
      <SessionRole userrole="logged-in">
        <CastLocation>
          <div className="fixed inset-0 bg-black text-white">
            {video && (
              <ContentTypeView
                key={video._id}
                contentType="video"
                view={app.populatedViews.mediaqueueCast.views.screen}
                value={video}
              />
            )}
            <details className="fixed top-3 left-3 z-[80] max-w-sm rounded-lg border border-white/20 bg-black/90 p-3 text-sm">
              <summary className="cursor-pointer font-semibold">Cast page diagnostics</summary>
              <p className="mt-2">Mode: {hd ? "HD" : "Low bandwidth"}</p>
              <p>Command: {video?.playState || "Waiting for a video"}</p>
              <p>
                Player:{" "}
                {playback?._id === video?._id
                  ? playback?.playState || (playback?.ready ? "Ready" : "Loading")
                  : "Loading"}
              </p>
              <p>Server save: {saved?._id === video?._id ? saved?.playState || "Saved" : "Waiting"}</p>
              <Link to="/video/incoming" className="mt-2 block underline">
                Choose a video
              </Link>
            </details>
          </div>
          <ContentTypeView contentType="video" view={app.populatedViews.mediaqueueCast.views.controls} />
        </CastLocation>
      </SessionRole>
    </CastContext.Provider>
  );
};

export default CastTest;
